var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMonth24DpE8Eaed1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 3.66671H16.5V1.83337H14.6667V3.66671H7.33333V1.83337H5.5V3.66671H4.58333C3.56583 3.66671 2.75917 4.49171 2.75917 5.50004L2.75 18.3334C2.75 19.3417 3.56583 20.1667 4.58333 20.1667H17.4167C18.425 20.1667 19.25 19.3417 19.25 18.3334V5.50004C19.25 4.49171 18.425 3.66671 17.4167 3.66671ZM17.4167 18.3334H4.58333V9.16671H17.4167V18.3334ZM8.25 12.8334H6.41667V11H8.25V12.8334ZM11.9167 12.8334H10.0833V11H11.9167V12.8334ZM15.5833 12.8334H13.75V11H15.5833V12.8334ZM8.25 16.5H6.41667V14.6667H8.25V16.5ZM11.9167 16.5H10.0833V14.6667H11.9167V16.5ZM15.5833 16.5H13.75V14.6667H15.5833V16.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonth24DpE8Eaed1);
export default __webpack_public_path__ + "static/media/calendar_month_24dp_E8EAED 1.51a2f668294cb4a375dcdb6bc8d4c8f9.svg";
export { ForwardRef as ReactComponent };